import React from 'react';
import { Container, Section } from '../ui/Section';
import { ButtonExternal } from '../ui/Button';
import { ScriptEyebrow } from '../ui/ScriptEyebrow';
import { Reveal } from '../motion/Reveal';
import { DoodleUnderline } from '../brand/Doodles';
import { DoodleScatter } from '../brand/DoodleScatter';
import { externalLinks } from '../../data/site';
export function FinalCta() {
  return <Section className="relative overflow-hidden bg-brand-blue py-16 sm:py-24" labelledBy="cta-heading" data-id="element-111" data-mp="1wq9eaag6492w">
      {/* Light-blue panel: scatter uses navy, cream, and yellow only. */}
      <DoodleScatter tone="blue" seed="final-cta-connect" layout="narrow" data-id="element-112" data-mp="1rpli7ad3121t" />
      <Container className="relative max-w-3xl" data-id="element-113" data-mp="26hnc8dsh10tx">
        <Reveal className="text-center" data-id="element-114" data-mp="21p2ifc9kenqe">
          <div className="flex justify-center" data-id="element-115" data-mp="21o14n015zn4z">
            <ScriptEyebrow data-id="element-116" data-mp="1dzrnwcit5pkp">There’s a place for you here</ScriptEyebrow>
          </div>
          <h2 id="cta-heading" className="mt-3 font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-brand-navy sm:text-6xl" data-id="element-117" data-mp="190yasl7fo0l2">
            We’d love to meet you.
          </h2>
          <DoodleUnderline className="mx-auto mt-3 h-4 w-56" color="var(--bcm-dark-blue)" data-id="element-118" data-mp="3rct92vv864wm" />
          <p className="mx-auto mt-6 max-w-xl font-sans text-[17px] leading-relaxed text-ink" data-id="element-119" data-mp="3w3t9ib3jz53v">
            Tell us a little about yourself, ask a question, or let a BCM leader help you take the
            next step.
          </p>

          <div className="mt-8 flex justify-center" data-id="element-120" data-mp="34eq0ki0q16kw">
            <ButtonExternal href={externalLinks.getConnectedForm} className="min-h-[56px] px-8 py-4 text-[17px] sm:text-lg" data-id="element-121" data-mp="38egxl3gucixv">
              Let’s Get Connected
            </ButtonExternal>
          </div>

          <div className="mt-6 flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-4" data-id="element-122" data-mp="3iehn575azvai">
            <ButtonExternal href={externalLinks.discord} variant="secondary" className="w-full sm:w-auto" data-id="element-123" data-mp="sn2tr4i65doz">
              Join the Discord
            </ButtonExternal>
            <ButtonExternal href={externalLinks.instagram} variant="secondary" className="w-full sm:w-auto" data-id="element-124" data-mp="7xqu262si0ej">
              Follow on Instagram
            </ButtonExternal>
            <ButtonExternal href={externalLinks.email} variant="secondary" className="w-full sm:w-auto" data-id="element-125" data-mp="hwpx994sd3u5">
              Email UCF BCM
            </ButtonExternal>
          </div>
        </Reveal>
      </Container>
    </Section>;
}